<div class="container display-flex justify-content-center f-align-items-center">
  <div class="pagination">
    @if (currentPage > 1) {
      <span class="icon-arrow-left"
            (click)="goToPage(currentPage - 1)">
      </span>
    }
    @for (page of pages; track $index) {
      @if (page) {
        <span class="pagination__item"
              [ngClass]="{'is-active': currentPage === page}"
              (click)="goToPage(page)">
          {{ page }}
        </span>
      } @else {
        <span>
          ...
        </span>
      }
    }
    @if (currentPage < pageCount) {
      <span class="icon-arrow-right"
            (click)="goToPage(currentPage + 1)">
      </span>
    }
  </div>
</div>
